import { BaseConnector } from './basic';

export class SolanaConnector extends BaseConnector {
  async connect(): Promise<string> {
    this.checkWindow();

    const { bitkeep } = window as any;
    if (!bitkeep?.solana) {
      throw new Error('BitKeep Solana not installed');
    }

    const response = await bitkeep.solana.connect();
    this.address = response.publicKey.toString();
    return this.address;
  }
  async switchNetwork(): Promise<string> {
    return null;
  }
  async sendTransaction(transaction): Promise<string> {
    this.checkWindow();

    const { bitkeep } = window as any;
    if (!bitkeep?.solana) {
      throw new Error('BitKeep not installed');
    }
    const provider = bitkeep.solana;
    const signature = await provider.signTransaction(transaction);
    return signature;
  }
}
